import React, { FC } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
// import Swiper core and required modules
import SwiperCore, { Navigation } from 'swiper'

import YearCard from '../YearCard'

// Import Swiper styles
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css'

import { Timeline, HR } from '../../styles/newsStyles'
import * as SC from './styles'


import Link from 'next/link'
import { getSlides, getYearImage } from './utils'
import { Year } from '../../models/history'

// install Swiper modules
SwiperCore.use([Navigation])

type Props = {
  activeYear: number
  yearsInfo: Year[]
}

const TimelineSlider: FC<Props> = ({ activeYear, yearsInfo }) => {
  const linksPerSlide = 5
  
  const slides = React.useMemo(() => getSlides(linksPerSlide, yearsInfo), [yearsInfo, linksPerSlide])
  const getStartIndex = (activeYear: number) => {

    for (let i = 0; i < slides.length; i++) {
      const slide = slides[i];
      for (let j=0; j < slide.length; j++) {
        const element = slide[j] 
        if (element.year === activeYear) {
          return i
        }
      }
    
  }
  return slides.length - 1
}

const startIndex = getStartIndex(activeYear)
  
  
  return (
    <SC.TimelineSlider>
      <SC.DesktopWrapper>
        <HR />
        <Swiper navigation className="swiper" initialSlide={startIndex}>
          {slides.map((slide, slideIndex) => (
            <SwiperSlide key={slideIndex}>
              <Timeline isFullSlide={slide.length % linksPerSlide === 0}>
                {slide.map((currentYearInfo, index) => (
                  <Link
                    href={`/history?year=${currentYearInfo.year}`}
                    as={`/history/${currentYearInfo.year}`}
                    passHref
                    key={currentYearInfo.year}
                  >
                    <YearCard
                      isActive={currentYearInfo.year === activeYear}
                      isReversed={(index + slideIndex) % 2 !== 0}
                      yearInfo={currentYearInfo}
                      yearImage={getYearImage(
                        currentYearInfo.year,
                        activeYear
                      )}
                    />
                  </Link>
                ))}
              </Timeline>
            </SwiperSlide>
          ))}
        </Swiper>
      </SC.DesktopWrapper>
      <SC.MobileWrapper>
        <Timeline isFullSlide={false}>
          <HR />
          {yearsInfo.map((currentYearInfo, index) => (
            <Link
              href={`/history?year=${currentYearInfo.year}`}
              as={`/history/${currentYearInfo.year}`}
              passHref
              key={currentYearInfo.year}
            >
              <YearCard
                isActive={currentYearInfo.year === activeYear}
                isReversed={index % 2 !== 0}
                yearInfo={currentYearInfo}
                yearImage={getYearImage(
                  currentYearInfo.year,
                  activeYear
                )}
              />
            </Link>
          ))}
        </Timeline>
      </SC.MobileWrapper>
    </SC.TimelineSlider>
  )
}

export default TimelineSlider
